module.exports = __webpack_public_path__ + "static/img/velvetAshes.3f5a896.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/posters/velvetAshes.jpg
// module id = 8
// module chunks = 0